import { Navigate, RouteObject } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';
import { ReleaseDetailsFormRedirect } from 'app/components/Releases/ReleaseTypeRedirect';
import { VersionCreditsList } from 'app/components/Releases';
import { VersionLyrics } from 'app/components/Releases/VersionLyrics/VersionLyrics';
import { VersionSplits } from 'app/components/Releases/VersionSplits';
import { VersionAudio } from 'app/components/Releases/VersionAudio';

export const releaseVersionRoutes: RouteObject[] = [
  {
    path: routes.releaseVersionDetails.route,
    element: <ReleaseDetailsFormRedirect />,
  },
  {
    path: routes.releaseVersionAudio.route,
    element: <VersionAudio />,
  },
  {
    path: routes.releaseVersionCredits.route,
    element: <VersionCreditsList />,
  },
  {
    path: routes.releaseVersionLyrics.route,
    element: <VersionLyrics />,
  },
  {
    path: routes.releaseVersionSplits.route,
    element: <VersionSplits />,
  },
  {
    path: '*',
    element: <Navigate to={routes.releaseVersionDetails.route} />,
  },
];
